import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PopupComponent from '../../../../commons/components/Popup/PopupComponent';
import ROUTERS from '../../../../commons/constans/router';
import { formatTimeZone } from '../../../../utils/helpers';
import SwiperSlide from "./../../../../commons/components/Slider"

const LoadingImage = () => null
const LoadingVideo = () => null

const CategoryTabContent = ({categories, active, albums, loading}) => {
  const navigate = useNavigate();
  const [showPopupImg, setShowPopupImg] = useState(null);
  const goToVideoDetail = (file) => {
    navigate(ROUTERS.VIDEO_DETAIL_PATH(file?.id || null), {state: {prevPath: 'prevPath'}});
  }

  const goToImageDetail = (item) => {
    // navigate(ROUTERS.ALBUM_DETAIL_PATH(item.id), {
    //   state: {item}
    // });
    setShowPopupImg(item);
  }

  const _handleCloseModal = () => {
    setShowPopupImg(null);
  }

  const data = albums[active.value] instanceof Array ? albums[active.value] : []

  const imageTab = loading && !data.length ? <LoadingImage /> : 
    <SwiperSlide
      spaceBetween={0}
      slidesPerView={2.3}
    >
      {data.map((e, key) => (
        <div className="img-slide" key={key}>
          <img
            className="img"
            src={e.photo_url?.thumbnail}
            alt=""
            onClick={() => goToImageDetail(e)}
          />
        </div>
      ))}
    </SwiperSlide>

  const videoTab = loading && !data.length ? <LoadingVideo /> : 
    <div className="video-message-marker mb-0 pt-0">
      <div className="swiper-pagination__maker">
        <SwiperSlide
          spaceBetween={10}
          slidesPerView={1}
          pagination={true}
          classSlider="swiper-pagination__custom"
        >
          {data.map((e, key) => (
            <div className="box-video" key={key}>
              <div className="box-video__thumbnail" onClick={() => goToVideoDetail(e)}>
                <div className="overlay"></div>
                <img
                  className="thumbnail-img"
                  src={e.video_message ? e.photo_url : e.photo_url?.thumbnail}
                  alt=""
                />
                <div className="box-video__thumbnail__icon-play">
                  <img
                    src="/images/album/icon_play-btn.svg"
                    alt=""
                    
                  />
                </div>
              </div>
              <div className="box-video__title">
                <div className="box-video__title__left w-100">
                  <h4 className="title text-truncate">{e.video_message?.title}</h4>
                  {/*<label className="content">
                    뽀로로 친구로부터 편지가 도착했어요!
                  </label>*/}
                </div>
                <div className="box-video__title__right">
                  {/*<img src="/images/icon_share_black.svg" alt="" />*/}
                </div>
              </div>
            </div>
          ))}
        </SwiperSlide>
      </div>
    </div>

  return (
    <div className="tabs__content">
      {categories.map((item, key) => (
        <div
          className={`tabs__content__section tabs__content__section--main ${item.contentType}${item.value === active.value ? " active" : ""}`}
          key={key}
        >
          {item.contentType === 'image' && imageTab}
          {item.contentType === 'video' && videoTab}
        </div>
      ))}

        {
          showPopupImg && <PopupComponent
          id={"MD6"}
          show={showPopupImg ? true : false}
          handleClose={_handleCloseModal}
          style={{ width: "calc(100vw - 50px"}}
          // bodyStyle={{height: "80vh"}}
          headingStyle={{borderBottom: "2px solid rgb(17 17 17 / 20%)"}}
          title={"이미지 상세보기"}
        >
          <div className="modal-voting-avatar-user d-flex justify-content-center">
            <div className="modal-voting-avatar-user__item">
              <img
                className="modal-voting-avatar-user__item__avatar"
                src={showPopupImg?.photo_url?.original || ''}
                alt=""
              />
              <p className="modal-voting-avatar-user__item__bthday">
                {formatTimeZone(showPopupImg?.created_at || '')}
              </p>
            </div>
          </div>
        </PopupComponent>
        }
        
    </div>
  )
}

export default CategoryTabContent
